/*
Pigmented Topcoats
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Pigmented Topcoats'
const id = 'JkIPZ98QXsdQ6qlsjB3c'

export default {
  name,
  id,
  filters,
  headers,
  form
}
